module.exports = __webpack_public_path__ + "static/media/4.253ebfef.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/4.png
// module id = 1404
// module chunks = 0